export var ShownValuesTypes;
(function (ShownValuesTypes) {
    ShownValuesTypes["All"] = "all";
    ShownValuesTypes["BiggerThan"] = "biggerThan";
    ShownValuesTypes["Top"] = "top";
    ShownValuesTypes["Bottom"] = "bottom";
})(ShownValuesTypes || (ShownValuesTypes = {}));
